export default __webpack_public_path__ + "static/media/gum1.53d1299e.png";